






























































import {Component, Prop, Vue} from 'vue-property-decorator';
import {SelectableStore} from '@/components/mass-import/SelectableStore';
import StoreSelectionSummary from '@/components/mass-import/steps/StoreSelectionSummary.vue';

@Component({
  components: {StoreSelectionSummary}
})
export default class SelectSitesStep extends Vue {

  @Prop({default: []}) readonly selectableStores: SelectableStore[];
  @Prop({default: {value: false}}) readonly allStoresSelectedContainer: {value: boolean};
  @Prop({default: {value: null}}) readonly uploadedFileContainer: {value?: File};
  @Prop({default: () => {}}) readonly nextStepHandler: () => void;

  public searchTerm: string = '';

  public onStoreSelectionChange() {
    this.allStoresSelectedContainer.value = this.selectableStores.length === this.selectableStores.filter(selectableStore => selectableStore.checked).length;
  }

  public refreshList() {
    this.selectableStores.forEach(selectableStore => {
      if (this.searchTerm.trim().length < 1) {
        selectableStore.displayed = true;
      }
      const searchRegExp: RegExp = new RegExp(this.searchTerm
          .trim()
          .split('')
          // escape regex special chars
          .map(char => char.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&').concat('.*'))
          .join(''), "i");
      selectableStore.displayed = searchRegExp.test(selectableStore.store.storeLabel);
    });
  }

  public async importFileChange(event: any) {
    if (!event.target.files[0]) {
      return;
    }
    this.uploadedFileContainer.value = event.target.files[0];
    this.nextStepHandler();
  }

  get hasSelection() {
    return this.allStoresSelectedContainer.value || this.selectableStores.filter(store => store.checked).length > 0;
  }
}
